import { Account, IRiskTolerance } from '../sp-types/accountTypes';

export const getRiskTolerance = (materialId: string, account: Account): IRiskTolerance | undefined =>
  account.materialsToAccount.find((m) => m.materialId === materialId)?.RiskTolerance;

export const createEmptyRiskTolerance = (
  riskDanger: number = 0,
  riskWarn: number = 0,
  riskGood: number = 0,
): IRiskTolerance => ({
  dangerAreaMinus: { start: -riskDanger, end: -riskWarn },
  stableArea: { start: -riskGood, end: riskGood },
  dangerAreaPlus: { start: riskWarn, end: riskDanger },
});

export function getSortedRouteIdsByMaterialId(account: Account, materialId: string): string[] | undefined {
  return account.materialsToAccount
    .find((material) => material.materialId === materialId)
    ?.RoutePriority?.sort((a, b) => a.order - b.order)
    .map((priority) => priority.routeId);
}
